import * as React from "react";
import VideoCard from "../atoms/VideoCard";
import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import "./CardDisplay.css";
import { config } from "../App.js";

const myDebounce = function (callBackFn, delay) {
  let clearTime;
  return function () {
    let self = this;
    let args = arguments;
    clearTimeout(clearTime);
    clearTime = setTimeout(() => {
      callBackFn.apply(self, args);
    }, delay);
  };
};

const debounceMethod = myDebounce((handleNewDSearchData, searchText) => {
  handleNewDSearchData(searchText);
}, 300);

export default function CardDisplay(props) {
  const { ageFilters, genreFilters, sortBy, search } = props;

  const [videoData, setVideoData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchVideos = async (url) => {
    try {
      const res = await axios.get(url);
      const result = res.data;
      setVideoData(result.videos);
      setIsLoaded(true);
    } catch (error) {
      setVideoData([]);
      console.log(error);
      setIsLoaded(false);
    }
  };

  useEffect(() => {
    let url = config.endpoint;
    let urlparam = "";

    if (search !== "") {
      url += "?title=" + search;
      debounceMethod((searchText) => {
        fetchVideos(searchText);
      }, url);
    } else {
      if (genreFilters) {
        if (!genreFilters["All Genre"]) {
          let params = "";
          for (let item in genreFilters) {
            if (genreFilters[item]) {
              if (params === "") {
                params = "?genres=" + item;
                urlparam = params;
                url += params;
                // string += "," + item;
              } else {
                url += "," + item;
              }
            }
          }
        }
      }

      if (ageFilters) {
        if (!ageFilters["Any age group"]) {
          let params = "";
          for (let item in ageFilters) {
            if (ageFilters[item]) {
              if (params === "") {
                if (urlparam != "") {
                  params = "&contentRating=" + encodeURIComponent(item);
                  url += params;
                } else {
                  params = "?contentRating=" + encodeURIComponent(item);
                  url += params;
                }

                // string += "," + item;
              } else {
                url += encodeURIComponent(item);
              }
            }
          }
        }
      }
      if (sortBy) {
        if (urlparam != "") {
          url += "&sortBy=" + sortBy;
        } else {
          url += "?sortBy=" + sortBy;
        }
      }
      fetchVideos(url);
    }
  }, [ageFilters, genreFilters, sortBy, search]);
  return (
    <>
      {isLoaded ? (
        <Box sx={{ flexGrow: 1 }} className="box">
          <div className="grid">
            <Grid container spacing={1}>
              {videoData ? (
                videoData.map((item, idx) => {
                  return (
                    <Grid key={item.title} item xm={12} xs={6} md={4} lg={3}>
                      <VideoCard
                        imgLink={item.previewImage}
                        title={item.title}
                        releaseDate={item.releaseDate}
                        _id={item._id}
                      />
                    </Grid>
                  );
                })
              ) : (
                <></>
              )}
            </Grid>
          </div>
        </Box>
      ) : (
        <Box className="loading" sx={{ display: "flex", margin: "0 auto" }}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
